var map = {
	"./AD.png": "acd1",
	"./AE.png": "b166",
	"./AF.png": "1440",
	"./AG.png": "1bc4",
	"./AI.png": "6cc7",
	"./AL.png": "a081",
	"./AM.png": "1902",
	"./AO.png": "c20f",
	"./AR.png": "3e5d",
	"./AS.png": "ea2a",
	"./AT.png": "27d3",
	"./AU.png": "b7d8",
	"./AW.png": "20d0",
	"./AX.png": "6336",
	"./AZ.png": "c805",
	"./BA.png": "5975",
	"./BB.png": "6f5c",
	"./BD.png": "e55f",
	"./BE.png": "b690",
	"./BF.png": "94e7",
	"./BG.png": "d712",
	"./BH.png": "b402",
	"./BI.png": "cae7",
	"./BJ.png": "23c2",
	"./BM.png": "2d92",
	"./BN.png": "5437",
	"./BO.png": "0a5b",
	"./BQ.png": "ad1b",
	"./BR.png": "c5ac",
	"./BS.png": "601d",
	"./BT.png": "cac5",
	"./BW.png": "642f",
	"./BY.png": "82ec",
	"./BZ.png": "0c81",
	"./CA.png": "43f3",
	"./CC.png": "5560",
	"./CD.png": "2988",
	"./CF.png": "fbfb",
	"./CG.png": "aea5",
	"./CH.png": "1008",
	"./CI.png": "8868",
	"./CK.png": "4d78",
	"./CL.png": "ac4e",
	"./CM.png": "91bb",
	"./CN.png": "702c",
	"./CO.png": "1ae5",
	"./CR.png": "d059",
	"./CU.png": "e41a",
	"./CV.png": "1bd7",
	"./CW.png": "d4bf",
	"./CX.png": "e493",
	"./CY.png": "4890",
	"./CZ.png": "735c",
	"./DE.png": "b933",
	"./DJ.png": "84f2e",
	"./DK.png": "cd11",
	"./DM.png": "f08d",
	"./DO.png": "e8cf",
	"./DZ.png": "76ca",
	"./EC.png": "fb38",
	"./EE.png": "4f22",
	"./EG.png": "20f1",
	"./EH.png": "80a8",
	"./ER.png": "fcc6",
	"./ES.png": "60a8",
	"./ET.png": "07b7",
	"./FI.png": "934d",
	"./FJ.png": "9397",
	"./FK.png": "31d5",
	"./FM.png": "d6fe",
	"./FO.png": "000d",
	"./FR.png": "3c2d",
	"./GA.png": "49a2",
	"./GB.png": "2009",
	"./GD.png": "0c5d",
	"./GE.png": "0063",
	"./GG.png": "42bb",
	"./GH.png": "01f7",
	"./GI.png": "ab0d",
	"./GL.png": "9b6a",
	"./GM.png": "0ff6",
	"./GN.png": "ae0a",
	"./GQ.png": "81a2",
	"./GR.png": "5e47",
	"./GT.png": "3119",
	"./GU.png": "2469",
	"./GW.png": "1196",
	"./GY.png": "ca4c",
	"./HK.png": "b920",
	"./HN.png": "2c496",
	"./HR.png": "fe7f",
	"./HT.png": "ac13",
	"./HU.png": "7eab",
	"./ID.png": "a52a",
	"./IE.png": "0610",
	"./IL.png": "c9d1",
	"./IM.png": "c64b",
	"./IN.png": "22b9",
	"./IO.png": "8f4c",
	"./IQ.png": "bdc7",
	"./IR.png": "8c07",
	"./IS.png": "fbe0",
	"./IT.png": "33e3",
	"./JE.png": "a090",
	"./JM.png": "3bf6",
	"./JO.png": "ea21",
	"./JP.png": "e691",
	"./KE.png": "f342",
	"./KG.png": "5c68",
	"./KH.png": "ba68",
	"./KI.png": "5e61",
	"./KM.png": "f6f7",
	"./KN.png": "2709",
	"./KR.png": "850c",
	"./KW.png": "76a4",
	"./KY.png": "b853",
	"./KZ.png": "9961",
	"./LA.png": "2ed8",
	"./LB.png": "ad6c",
	"./LI.png": "a434",
	"./LK.png": "ea51",
	"./LR.png": "919b",
	"./LS.png": "cb97",
	"./LT.png": "560a",
	"./LU.png": "84a9",
	"./LV.png": "26cc",
	"./LY.png": "54f4",
	"./MA.png": "e344",
	"./MC.png": "4ae7",
	"./MD.png": "11c0",
	"./ME.png": "5c8d",
	"./MG.png": "5b1a",
	"./MH.png": "b9f1",
	"./MK.png": "b0d1",
	"./ML.png": "f119",
	"./MM.png": "accd",
	"./MN.png": "26e0",
	"./MO.png": "ad10",
	"./MP.png": "ca1f",
	"./MQ.png": "e0e1",
	"./MR.png": "a7be",
	"./MS.png": "1510",
	"./MT.png": "6fec",
	"./MU.png": "5fa2",
	"./MV.png": "5b73",
	"./MW.png": "2b03",
	"./MX.png": "d4a1",
	"./MY.png": "b1e4",
	"./MZ.png": "8e48",
	"./NA.png": "8fad",
	"./NE.png": "e568",
	"./NF.png": "daec",
	"./NG.png": "1d5a",
	"./NI.png": "00e6",
	"./NL.png": "7f2c",
	"./NO.png": "b9a4",
	"./NP.png": "f37f",
	"./NR.png": "76fb",
	"./NU.png": "9bc5",
	"./NZ.png": "3849",
	"./OM.png": "6034",
	"./PA.png": "bf04",
	"./PE.png": "77c5",
	"./PF.png": "e298",
	"./PG.png": "fe2e",
	"./PH.png": "8c3a",
	"./PK.png": "f4fe",
	"./PN.png": "c893",
	"./PO.png": "a4e9",
	"./PR.png": "3a0f",
	"./PS.png": "de17",
	"./PT.png": "e768",
	"./PW.png": "0fd0",
	"./PY.png": "8d73",
	"./QA.png": "9abbd",
	"./RO.png": "9612",
	"./RS.png": "b43e",
	"./RU.png": "86cc8",
	"./RW.png": "fe13",
	"./SA.png": "d996",
	"./SB.png": "d575",
	"./SC.png": "bdb4",
	"./SD.png": "1ef5",
	"./SE.png": "fab7",
	"./SG.png": "06d4",
	"./SI.png": "2fb6",
	"./SK.png": "7715",
	"./SL.png": "df58",
	"./SM.png": "cecd",
	"./SN.png": "8a12",
	"./SO.png": "f2bc",
	"./SR.png": "3367",
	"./SS.png": "df59",
	"./ST.png": "f5a3",
	"./SV.png": "a166",
	"./SX.png": "050a",
	"./SY.png": "44ba",
	"./SZ.png": "25b3",
	"./TB.png": "bed6",
	"./TC.png": "f074",
	"./TD.png": "b657",
	"./TG.png": "f6a1",
	"./TH.png": "dd8b",
	"./TJ.png": "4ede",
	"./TK.png": "4080",
	"./TL.png": "5a15",
	"./TM.png": "aef1",
	"./TN.png": "d720",
	"./TO.png": "0ea0",
	"./TR.png": "a0a7",
	"./TT.png": "e93a",
	"./TV.png": "c75e",
	"./TW.png": "8ee1",
	"./TZ.png": "2e8b",
	"./UA.png": "e0c2",
	"./UE.png": "21be6",
	"./UG.png": "6d7a",
	"./US.png": "3fd2",
	"./UY.png": "7196",
	"./UZ.png": "6db5",
	"./VA.png": "5700",
	"./VE.png": "e62f",
	"./VG.png": "f327",
	"./VI.png": "bf74",
	"./VN.png": "e04d",
	"./VU.png": "58c3",
	"./WS.png": "b84c",
	"./XK.png": "f07e",
	"./YE.png": "e692",
	"./ZA.png": "7ea3",
	"./ZM.png": "b36a",
	"./ZW.png": "d014",
	"./abkhazia.png": "b88c",
	"./azores-islands.png": "fdba",
	"./balearic-islands.png": "e5aa",
	"./basque-country.png": "9ff1",
	"./bhutan-1.png": "e1e6",
	"./british-columbia.png": "1257",
	"./canary-islands.png": "89d5",
	"./ceuta.png": "9225",
	"./corsica.png": "9609",
	"./england.png": "2bbe",
	"./galapagos-islands.png": "5154",
	"./hawaii.png": "a9ec",
	"./madeira.png": "8fd4",
	"./melilla.png": "855e",
	"./nato.png": "b75d",
	"./north-korea.png": "d1a6",
	"./northen-cyprus.png": "e52d",
	"./orkney-islands.png": "8bda",
	"./ossetia.png": "7999",
	"./rapa-nui.png": "0276",
	"./saba-island.png": "16c5",
	"./sardinia.png": "a2c7",
	"./scotland.png": "0046",
	"./sint-eustatius.png": "5104",
	"./somaliland.png": "a0e8",
	"./st-barts.png": "1291",
	"./st-lucia.png": "b1e8",
	"./st-vincent-and-the-grenadines.png": "eeb0",
	"./transnistria.png": "c946",
	"./united-nations.png": "0d6da",
	"./wales.png": "b720"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "094a";